import { CardHeader, CardBody, Card } from 'reactstrap';
import styled from 'styled-components';
import { colors } from 'global/colors';

export const CollapseContainer = styled(Card)`
  display: block;
  width: 100%;
  border: 1px solid ${colors.darkBlue};
  margin-bottom: 10px;
  &.active {
    transform: scale(1.01);
    transition: all ease-in 0.2s;
  }
`;

export const ActionIcon = styled.span`
  font-size: 20px;
  padding: 0 5px;
  color: ${colors.black};
  position: absolute;
  right: 10px;

  &.active {
    color: ${colors.white};
  }
`;

export const CollapseHeader = styled(CardHeader)`
  display: block;
  align-content: center;
  border-bottom: 1px solid ${colors.darkBlue};
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: ${colors.white};
  }

  &.active {
    background: ${colors.darkBlue};
    color: ${colors.white};
  }
`;

// TODO: this transition isn't working yet!! need to fix it
export const CollapseBody = styled(CardBody)`
  height: auto;
  transition: all, 0.3s linear;

  &.hidden {
    height: 0;
    transition: all, 0.3s linear;
  }
`;

export const HeadingTitle = styled.div``;

export const Description = styled.div`
  font-size: 14px;
`;

export const TitleAndActionContainer = styled.div`
  display: flex;
`;
